<template>
  <section v-if="keyChainProduct && Number(keyChainProduct.keyChainPrice) > 0">
    <h2 class="mb-0 font-weight-bold">{{ $t('otherProductSelect.keyChain.title') }}</h2>
    <h3 class="text-dark font-weight-bold"></h3>
    <b-row>
      <b-col cols="4">
        <b-img
          src="https://us.docupet.com/media/uploads/public/system/da/b9/dab9f78e20a296b989702d7f98dafbe6e024e91d4d3a6445c8f770313c079f2a.jpeg"
          fluid
          center
          class="key-chain-img"
          alt=""
        />
      </b-col>
      <b-col cols="8">
        <div>
          <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
          <h3 class="text-dark" v-html="$t('otherProductSelect.keyChain.description')" />
          <b-checkbox id="product-style-key-chain" v-model="keyChainSelected" size="lg" @change="setKeyChainSelected">
            <h3 class="pt-1" :class="!keyChainSelected ? 'text-dark' : 'text-primary'">
              {{
                $t('otherProductSelect.keyChain.text', [
                  Number(keyChainProduct.keyChainDiscountedPrice || keyChainProduct.keyChainPrice).toFixed(2),
                ])
              }}
            </h3>
          </b-checkbox>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {
  name: 'KeyChainProductSelect',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    keyChainProduct: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      keyChainSelected: this.value,
    };
  },
  methods: {
    setKeyChainSelected(selected) {
      this.keyChainSelected = selected;
      this.$emit('input', this.keyChainSelected);
    },
  },
};
</script>

<style lang="scss" scoped></style>
